module.exports = __webpack_public_path__ + "static/img/5_03.66d5bc92.png";